"use client";
import Link from "next/link";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-[#0b1220] to-[#1d3557] py-16 px-6 lg:px-12 border-t border-gray-200" aria-label="Footer navigation and information">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
        
        {/* Left - About */}
        <div>
          <h3 className="text-2xl font-bold text-white mb-4">MidaPOS</h3>
          <p className="text-gray-600 text-base leading-relaxed">
          Florida, Miami based modern POS & payment solutions built for small businesses. We partner with top ISOs. No contracts. Free hardware. Full instant support. Next day settlement.
          </p>
        </div>

        {/* Middle - Navigation */}
        <div className="grid grid-cols-2 gap-6">
          <nav aria-label="Solutions navigation">
            <h4 className="font-semibold text-white mb-2">Solutions</h4>
            <ul className="text-gray-300 space-y-1 text-sm">
              <li><a href="/solutions">POS Systems</a></li>
              <li><a href="/solutions">EBT & Contactless</a></li>
              <li><a href="/solutions">Online Store</a></li>
              <li><a href="/products">Products</a></li>
            </ul>
          </nav>
          <nav aria-label="Company navigation">
            <h4 className="font-semibold text-white mb-2">Company</h4>
            <ul className="text-gray-300 space-y-1 text-sm">
              <li><a href="/pricing">Pricing</a></li>
              <li><a href="/testimonials">Testimonials</a></li>
              <li><a href="/faqs">FAQ</a></li>
              <li><a href="/blog">Blog</a></li>
            </ul>
          </nav>
        </div>

        {/* Right - Call to Action */}
        <div>
          <h4 className="font-semibold text-white mb-2">Need help choosing?</h4>
          <p className="text-gray-300 mb-4 text-sm">
            Get a free consultation and see what solution fits best. No pressure.
          </p>
          <p className="text-gray-300 mb-4 text-sm">
            Call us: <a href="tel:8006747295" className="underline hover:text-white">(800) 674-7295</a>
          </p>
          <Link
            href="/get-started"
            aria-label="Get Started"
            className="inline-block bg-[#036f82] hover:bg-[#025e6c] text-white font-semibold px-6 py-2 rounded-md transition"
          >
            Get Started
          </Link>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t  border-gray-200 mt-12 pt-6 text-center text-sm text-gray-400">
        <div className="flex  flex-col lg:flex-row justify-between items-center max-w-[1560px] mx-auto gap-4">
          <p>© 2025 MidaPOS. All rights reserved.</p>
          <div className="space-x-4">
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
            <a href="/sitemap.xml">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
}